import axios from 'axios'
import {URL} from '../../env'
export default {
    data() {
        return {
            isos: [],
            eachUsers: [],
            industry: [],
        }
    },
    mounted(){
        // this.getAllIsos()
        // this.getEachUsers()
        this.getCompanyIndustries()
    },
    methods: {
        getAllIsos(){
            axios.get(`${URL}/api/iso/get_isos`).then(res=>{
                this.isos = res.data.data
            })
        },
        getEachUsers(){
            axios.get(`${URL}/api/user/get_each_users`).then(res=>{
                this.eachUsers = res.data.data
            })
        },
        getCompanyIndustries(){
            axios.get(`${URL}/api/company_industries`).then(res=>{
                this.industry = res.data
            })
        }
    }
    
    
}